// extracted by mini-css-extract-plugin
export var body = "index-module--body--SD9oZ";
export var container = "index-module--container--fBTA2";
export var details = "index-module--details--p6nLC";
export var heroImage = "index-module--heroImage--Nl08D";
export var invertedColorScheme = "index-module--invertedColorScheme--c4zX3";
export var joinUsButton = "index-module--joinUsButton--Cijfg";
export var label = "index-module--label--yLWQA";
export var mobileOnly = "index-module--mobileOnly--1n43i";
export var os1Body = "index-module--os1Body--2HqlW";
export var os1Title = "index-module--os1Title--4yPrS";
export var os2Body = "index-module--os2Body--SqOES";
export var os2Title = "index-module--os2Title--ajPFo";
export var osTitle = "index-module--osTitle--KuC7X";
export var title = "index-module--title--wDglf";